import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { HeaderInsuranceOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/header-insurance/header-insurance-wrapepr.component';

@Component({
  selector: 'app-header-insurance-mobile',
  templateUrl: './header-insurance-mobile.component.html',
  styleUrls: ['./header-insurance-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderInsuranceMobileComponent extends HeaderInsuranceOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
